import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { BackendService } from '../../../services/backend';
import { SseConnectionStatus } from '../../../model';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-sse-status',
	standalone: true,
	imports: [CommonModule, NzTooltipModule],
	template: `
		<span class="sse-dot"
			[class.connected]="status.state === 'connected'"
			[class.connecting]="status.state === 'connecting'"
			[class.disconnected]="status.state === 'disconnected'"
			[nzTooltipTitle]="tooltipText"
			nz-tooltip
			nzTooltipPlacement="bottom">
		</span>
	`,
	styles: [`
		.sse-dot {
			display: inline-block;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			margin-right: 8px;
			cursor: default;
			vertical-align: middle;
			transition: background-color 0.3s ease, box-shadow 0.3s ease;
		}
		.sse-dot.connected {
			background-color: #52c41a;
			box-shadow: 0 0 4px rgba(82, 196, 26, 0.6);
		}
		.sse-dot.connecting {
			background-color: #faad14;
			box-shadow: 0 0 4px rgba(250, 173, 20, 0.6);
			animation: pulse 1.2s ease-in-out infinite;
		}
		.sse-dot.disconnected {
			background-color: #ff4d4f;
			box-shadow: 0 0 4px rgba(255, 77, 79, 0.6);
		}
		@keyframes pulse {
			0%, 100% { opacity: 1; }
			50% { opacity: 0.4; }
		}
	`]
})
export class SseStatusComponent implements OnInit, OnDestroy {
	status: SseConnectionStatus = { state: 'connecting', since: Date.now() };
	tooltipText = '';

	private sub!: Subscription;
	private tooltipInterval: any;

	constructor(private backend: BackendService) {}

	ngOnInit() {
		this.sub = this.backend.sseStatus$.subscribe(s => {
			this.status = s;
			this.updateTooltip();
		});

		// Update tooltip every second for live elapsed time
		this.tooltipInterval = setInterval(() => this.updateTooltip(), 1000);
	}

	ngOnDestroy() {
		this.sub?.unsubscribe();
		clearInterval(this.tooltipInterval);
	}

	private updateTooltip() {
		const elapsed = Date.now() - this.status.since;

		switch (this.status.state) {
			case 'connected': {
				const h = Math.floor(elapsed / 3600000);
				const m = Math.floor((elapsed % 3600000) / 60000);
				const s = Math.floor((elapsed % 60000) / 1000);
				let text = `Connected for ${h}h ${m}m ${s}s`;
				if (this.status.lastPing != null) {
					const pingAgo = Math.floor((Date.now() - this.status.lastPing) / 1000);
					text += ` | Last ping: ${pingAgo}s ago`;
				} else {
					text += ` | No ping yet`;
				}
				this.tooltipText = text;
				break;
			}
			case 'connecting': {
				const s = Math.floor(elapsed / 1000);
				this.tooltipText = `Connecting... ${s}s`;
				break;
			}
			case 'disconnected': {
				this.tooltipText = `Disconnected: ${this.status.error || 'Unknown error'}`;
				break;
			}
		}
	}
}
